import React from 'react';
import { LD_DOCUMENTS_DOCUMENT_BUILDER } from 'constants/featureFlags';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PageToolbar from './PageToolbar';
import LegacyPageToolbar from './LegacyPageToolbar';
import { PageToolbarProps } from './types';

export default function PagesToolbar(props: PageToolbarProps) {
  const { [LD_DOCUMENTS_DOCUMENT_BUILDER]: flag } = useFlags();

  return flag ? (
    <PageToolbar
      className={props.className}
      editor={props.editor}
      onChooseGalleryPhoto={props.onChooseGalleryPhoto}
    />
  ) : (
    <LegacyPageToolbar
      className={props.className}
      editor={props.editor}
      onPhotoChoose={props.onChooseGalleryPhoto}
    />
  );
}
